import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { useApiClient } from '@/api/clients/useApiClient.util.ts';
import { CreateIndividualCustomerRequestDto, CustomerCreationResponseDto } from '@/api/generated';
import { useCustomerCreateMutationOptions } from '@/views/customers/status/useCustomerMutationOptions.util.ts';

type Return = {
  createIndividualCustomer: (
    req: CreateIndividualCustomerRequestDto,
  ) => Promise<CustomerCreationResponseDto>;
  isCreatingIndividualCustomer: boolean;
};

export const useCreateIndividualCustomer = (): Return => {
  const { customersApi } = useApiClient();
  const createOptions = useCustomerCreateMutationOptions();

  const { isPending, mutateAsync } = useMutation<
    CustomerCreationResponseDto,
    AxiosError,
    CreateIndividualCustomerRequestDto
  >({
    ...createOptions,
    mutationFn: async req => {
      const res = await customersApi.createIndividualCustomer(req);

      return res.data;
    },
  });

  return {
    createIndividualCustomer: mutateAsync,
    isCreatingIndividualCustomer: isPending,
  };
};
